export default __webpack_public_path__ + "static/media/Aurora - Stand Alone.cb7320b9.svg";